var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("SoliForm", {
    ref: "form",
    attrs: {
      title: _vm.mode.Teacher
        ? "Add New Teacher"
        : _vm.mode.Student
        ? `Create New ${_vm.adult ? "Student" : "Family"}`
        : "Add Staff Member",
      text: "Save",
      icon: "save",
      "limit-scroll": _vm.$vuetify.breakpoint.sm,
      "mobile-scroll": _vm.$vuetify.breakpoint.xs,
      errors: _vm.errors,
      persistent: "",
    },
    on: {
      reset: function ($event) {
        return _vm.$emit("reset")
      },
      submit: _vm.submit,
    },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c(
              "div",
              { staticClass: "flex flex-col gap-4" },
              [
                _vm.mode.Student
                  ? _c("v-switch", {
                      staticClass: "mb-1 mt-0",
                      attrs: {
                        label: "This is an adult student",
                        dense: "",
                        "hide-details": "auto",
                      },
                      model: {
                        value: _vm.adult,
                        callback: function ($$v) {
                          _vm.adult = $$v
                        },
                        expression: "adult",
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                !_vm.adult && _vm.mode.Student
                  ? _c("div", { staticClass: "soli-grey" }, [
                      _vm._v(
                        "\n                Parent Information:\n            "
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      [
                        _c("v-text-field", {
                          attrs: {
                            "prepend-inner-icon": "person",
                            label: "First Name",
                            outlined: "",
                            rules: _vm.rules.input,
                            dense: "",
                            "hide-details": "auto",
                          },
                          model: {
                            value: _vm.form.first_name,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "first_name", $$v)
                            },
                            expression: "form.first_name",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-col",
                      [
                        _c("v-text-field", {
                          attrs: {
                            label: "Last Name",
                            outlined: "",
                            rules: _vm.rules.input,
                            dense: "",
                            "hide-details": "auto",
                          },
                          on: {
                            input: function ($event) {
                              _vm.form.children.forEach(
                                (e) => (e.last_name = $event)
                              )
                            },
                          },
                          model: {
                            value: _vm.form.last_name,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "last_name", $$v)
                            },
                            expression: "form.last_name",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("SoliText", {
                  attrs: {
                    errors: _vm.errors.email,
                    rules: _vm.rules.email,
                    icon: "alternate_email",
                    label: "Email",
                    "hide-details": "auto",
                    validateOnBlur: "",
                  },
                  model: {
                    value: _vm.form.email,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "email", $$v)
                    },
                    expression: "form.email",
                  },
                }),
                _vm._v(" "),
                _c("SoliPhone", {
                  attrs: {
                    icon: "phone",
                    label: "Phone",
                    errors: _vm.errors.phone,
                    "hide-details": "auto",
                  },
                  model: {
                    value: _vm.form.phone,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "phone", $$v)
                    },
                    expression: "form.phone",
                  },
                }),
                _vm._v(" "),
                !_vm.adult && _vm.mode.Student
                  ? _c(
                      "div",
                      { staticClass: "mt-3" },
                      [
                        _c("v-divider"),
                        _vm._v(" "),
                        _c("div", { staticClass: "soli-grey my-5" }, [
                          _vm._v("Child Information:"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "py-3 flex flex-col gap-4" },
                          _vm._l(
                            _vm.form.children.length,
                            function (child, idx) {
                              return _c(
                                "v-row",
                                { key: child[idx] },
                                [
                                  _c(
                                    "v-col",
                                    { staticClass: "py-0" },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          "prepend-inner-icon": "person",
                                          label: "First Name",
                                          outlined: "",
                                          rules: _vm.rules.input,
                                          dense: "",
                                          "hide-details": "auto",
                                        },
                                        model: {
                                          value:
                                            _vm.form.children[idx].first_name,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form.children[idx],
                                              "first_name",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "form.children[idx].first_name",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    { staticClass: "py-0" },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: "Last Name",
                                          outlined: "",
                                          rules: _vm.rules.input,
                                          dense: "",
                                          "hide-details": "auto",
                                        },
                                        model: {
                                          value:
                                            _vm.form.children[idx].last_name,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form.children[idx],
                                              "last_name",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "form.children[idx].last_name",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }
                          ),
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "mt-3 pl-1" },
                          [
                            _c(
                              "v-btn",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.form.children.length <= 3,
                                    expression: "form.children.length <= 3",
                                  },
                                ],
                                staticClass: "soli-round soli-blue-text my-3",
                                attrs: { "x-small": "", outlined: "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.form.children.push({
                                      first_name: null,
                                      last_name: _vm.form.last_name,
                                    })
                                  },
                                },
                              },
                              [_vm._v("Add Another Child")]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.form.children.length > 1,
                                    expression: "form.children.length > 1",
                                  },
                                ],
                                staticClass:
                                  "soli-round soli-red-text my-3 ml-3",
                                attrs: { "x-small": "", outlined: "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.form.children.splice(-1)
                                  },
                                },
                              },
                              [_vm._v("Remove Child")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }